// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"295":"4f512a7d","385":"bbd5d621","654":"c976edb8","672":"86fca2c5","712":"7defbd39","853":"ee28cf1f","920":"be186163"}[chunkId] + ".chunk.js";
};